import React from 'react';
import {Route, Routes} from "react-router";
import ProjectPage from "./pages/project/ProjectPage";
import ProjectDetailPage from "./pages/project/ProjectDetailPage";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/route/ProtectedRoute";
import PageLayout from "./pages/layouts/PageLayout";
import NoMatchPage from "./pages/NoMatchPage";
import RegisterPage from "./pages/RegisterPage";
import ProjectMakeAppointmentPage from "src/pages/project/ProjectMakeAppointmentPage";
import ForgotPasswordPage from "src/pages/ForgotPasswordPage";
import DashboardPage from "src/pages/DashboardPage";
import BalanceHistoryPage from "src/pages/payment/BalanceHistoryPage";
import ChangeIbanPage from "src/pages/account/ChangeIbanPage";
import MyAccountDataPage from "src/pages/account/MyAccountDataPage";
import PayoutsPage from "src/pages/account/PayoutsPage";
import InviteSomeonePage from "src/pages/account/InviteSomeonePage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute><PageLayout /></ProtectedRoute>}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/projecten" element={<ProjectPage />} />
        <Route path="/projecten/:id" element={<ProjectDetailPage />} />
        <Route path="/projecten/:id/afspraak-maken" element={<ProjectMakeAppointmentPage />} />
        <Route path="/account/saldo" element={<BalanceHistoryPage />} />
        <Route path="/account/mijn-gegevens" element={<MyAccountDataPage />} />
        <Route path="/account/uitbetalingen" element={<PayoutsPage />} />
        <Route path="/account/rekeningnummer-wijzigen" element={<ChangeIbanPage />} />
        <Route path="/account/iemand-uitnodigen" element={<InviteSomeonePage />} />
      </Route>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registreren" element={<RegisterPage />} />
      <Route path="/wachtwoord-vergeten" element={<ForgotPasswordPage />} />
      <Route path="*" element={<NoMatchPage />} />
    </Routes>
  );
}

export default AppRoutes;

AppRoutes.propTypes = {}

AppRoutes.defaultProps = {}